// Textos de los ajustes de anuncios por zona (zone-ad-settings). Se registran junto al
// resto de vocabularios en AppComponent; setTranslation los fusiona.
export const locale = {
  lang: 'es',
  data: {
    ZONE_AD_SETTINGS: {
      TITLE: 'Ajustes de anuncios por zona',
      NOTE_TITLE: 'Borradores de anuncios para zonas sin match',
      NOTE_TEXT:
        'Cada cierto tiempo se buscan las rutinas que llevan tiempo sin match y se prepara un borrador de anuncio en Meta para su zona (una celda H3). Aquí se decide cuándo se hace, con qué valores nace cada borrador y con qué datos se publica.',
      LOADING: 'Cargando los ajustes…',
      ERROR_LOAD: 'No se han podido cargar los ajustes de anuncios por zona.',
      ERROR_FORBIDDEN: 'No tienes permiso para ver los ajustes de anuncios por zona.',
      RETRY: 'Reintentar',

      GENERAL_TITLE: 'Generación automática',
      GENERAL_SUB: 'Apagada, no se crean borradores nuevos.',
      ENABLED_LABEL: 'Generar borradores automáticamente',

      GENERATION_TITLE: 'Qué zonas entran',
      GENERATION_SUB: 'Tamaño de la zona y qué rutinas y zonas se tienen en cuenta en cada generación.',
      H3_RESOLUTION: 'Resolución H3',
      H3_RESOLUTION_HINT: 'Tamaño de la celda de cada zona, de 0 (la más grande) a 15 (la más pequeña).',
      NO_MATCH_HOURS: 'Horas sin match',
      NO_MATCH_HOURS_HINT: 'Horas que tiene que llevar una rutina sin match para contar, de 1 a 87.600.',
      COOLDOWN_DAYS: 'Días de espera por zona',
      COOLDOWN_DAYS_HINT: 'Días que espera una zona, tras cerrarse su último borrador, antes de recibir otro. De 0 a 365.',
      SCHEDULE_LABEL: 'Cuándo se genera',
      SCHEDULE_TIMES: 'A horas fijas',
      SCHEDULE_EVERY: 'Cada N horas',
      EVERY_HOURS_LABEL: 'Intervalo',
      EVERY_HOURS_ONE: 'Cada hora',
      EVERY_HOURS_OTHER: 'Cada {{count}} horas',
      TIME_ARIA: 'Hora {{n}}',
      ADD_TIME: 'Añadir hora',
      REMOVE_TIME: 'Quitar esta hora',
      SCHEDULE_HINT: 'Hora de Madrid.',

      DEFAULTS_TITLE: 'Valores de cada borrador',
      DEFAULTS_SUB: 'Con estos valores nace cada borrador generado.',
      RADIUS_KM: 'Radio (km)',
      RADIUS_KM_HINT: 'Radio del anuncio, de 1 a 80 km.',
      BUDGET: 'Presupuesto (€)',
      BUDGET_HINT: 'Presupuesto total de la campaña.',
      DURATION_DAYS: 'Duración (días)',
      DURATION_DAYS_HINT: 'Días que dura la campaña, de 1 a 90.',
      BUDGET_MINIMUM: 'Con estos valores, el presupuesto tiene que ser de al menos {{min}} (mínimo de Meta por plataforma y día × 2 plataformas × días).',
      ADVANTAGE_DEFAULT: 'Audiencia Advantage+ por defecto en los borradores nuevos',
      ADVANTAGE_HINT: 'Meta puede ampliar la edad y los intereses para mejorar el rendimiento; la zona sigue siendo un límite. Cada borrador se puede cambiar mientras está en borrador.',

      META_TITLE: 'Publicación en Meta',
      META_SUB: 'Datos que se envían a Meta con cada anuncio.',
      DSA_MISSING: 'Sin pagador y beneficiario no se puede publicar ningún borrador en Meta.',
      LANDING_URL: 'Página de destino',
      LANDING_URL_HINT: 'A dónde lleva el anuncio. Tiene que empezar por https://',
      DSA_PAYOR: 'Pagador (DSA)',
      DSA_PAYOR_HINT: 'Quién paga los anuncios, según la Ley de Servicios Digitales de la UE.',
      DSA_BENEFICIARY: 'Beneficiario (DSA)',
      DSA_BENEFICIARY_HINT: 'En nombre de quién se anuncia.',
      MIN_BUDGET_PER_DAY: 'Presupuesto mínimo de Meta por plataforma y día (€)',
      MIN_BUDGET_PER_DAY_HINT: 'Lo que exige Meta a cada conjunto de anuncios (Facebook e Instagram) por día.',

      UPDATED_AT: 'Última modificación',
      SAVE: 'Guardar cambios',
      SAVING: 'Guardando…',
      SAVE_DISABLED_HINT: 'Revisa los campos marcados para poder guardar',
      SAVED: 'Ajustes guardados',
      ERROR_SAVE: 'No se han podido guardar los ajustes',
      ERROR_FORBIDDEN_SAVE: 'No tienes permiso para cambiar los ajustes de anuncios por zona',
      ACCEPT: 'Aceptar',

      VALIDATION: {
        REQUIRED: 'Este campo es obligatorio.',
        INTEGER: 'Tiene que ser un número entero.',
        RANGE: 'Tiene que estar entre {{min}} y {{max}}.',
        MIN_BUDGET: 'El mínimo es {{min}}.',
        MAX_BUDGET: 'El máximo es {{max}}.',
        EURO_CENTS: 'Como mucho dos decimales.',
        HTTPS_URL: 'Tiene que ser una dirección que empiece por https://',
        MAX_LENGTH: 'Como mucho {{max}} caracteres.',
        TIMES_REQUIRED: 'Añade al menos una hora.',
        TIME_FORMAT: 'Formato HH:MM.',
      },
    },
  },
};
